// extracted by mini-css-extract-plugin
export default {"city":"classes_city__S0gta"};